export default __webpack_public_path__ + "static/media/less.9bdd2ab9.svg";